export default __webpack_public_path__ + "static/2-4105e4133891aaa3451148f6eaeb90a4.jpg";